import { render, staticRenderFns } from "./BrandingManage.vue?vue&type=template&id=5c5a4f68&scoped=true"
import script from "./BrandingManage.vue?vue&type=script&lang=js"
export * from "./BrandingManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5a4f68",
  null
  
)

export default component.exports